import * as Blogging from './Utils/blogging';

const merged = {
    ...Blogging,
}

export default merged;